import { PersonalDiscountedVariant } from 'api/product/getPersonalizedProductDetails/types';
import { OrderType } from 'constants/order';
import { Variant } from 'modules/product-details/types';

type Input = {
  variant?: PersonalDiscountedVariant;
  selectedVariant?: Variant;
  orderType: OrderType;
};

/**
 * Hooks to calculate Price per kilo
 */
const usePricePerKilo = ({ variant, selectedVariant, orderType }: Input) => {
  const oneOffPrice = Number(
    variant?.one_off.compare?.after || variant?.one_off.price || 0
  );
  const subscriptionPrice = Number(variant?.subscription?.compare.after || 0);

  const productWeight =
    selectedVariant &&
    (selectedVariant.weightUnit === 'GRAMS'
      ? selectedVariant.weight / 1000
      : selectedVariant.weight);
  const pricePerKilo =
    (orderType === OrderType.SUBSCRIPTION ? subscriptionPrice : oneOffPrice) /
    (productWeight || 1);

  return {
    pricePerKilo,
    oneOffPrice,
    subscriptionPrice,
  };
};

export default usePricePerKilo;
